module.exports = __webpack_public_path__ + "static/media/log-in.cd2aa80b.svg";